import React from 'react';
import type { VariantProps } from 'tailwind-variants';

import { styles } from './UiKitListCharacteristic.styles';
type Item = { label: React.ReactNode; value: React.ReactNode };
type Variants = VariantProps<typeof styles>;
export interface UiKitListCharacteristicProps {
  className?: string;
  items: Item[];
  classNameLabel?: string;
  classNameValue?: string;
  classNameItem?: string;
  type?: Variants['type'];
}

export function UiKitListCharacteristic({
  className,
  classNameLabel,
  classNameValue,
  items,
  classNameItem,
  type
}: UiKitListCharacteristicProps) {
  const slots = styles({ type });

  return (
    <div className={slots.base({ className })}>
      {items.map((item, index) => (
        <div
          key={index}
          className={slots.item({ className: classNameItem })}
        >
          <div className={slots.label({ className: classNameLabel })}>
            {item.label}
          </div>
          <div className={slots.value({ className: classNameValue })}>
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
}
